import "core-js/modules/es.array.some";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import "core-js/modules/es.string.starts-with";
// Vendor Libs
// Action Types
import { actionTypes } from '../action-types'; // Actions

import { submitService } from '../actions/service-actions';

var fetchService = function fetchService(dispatch, _ref, _ref2, _ref3) {
  var serviceKey = _ref.serviceKey;
  var serviceConfig = _ref2.serviceConfig;
  var service = _ref3.service;
  var params = service[serviceKey].params;
  return dispatch(submitService(serviceConfig, serviceKey, params));
};

var handleFulfilled = function handleFulfilled(dispatch, _ref4, _ref5, _ref6) {
  var serviceKey = _ref4.serviceKey;
  var serviceConfig = _ref5.serviceConfig;
  var service = _ref6.service;

  if (serviceKey && ['CREATE_', 'UPDATE_', 'DELETE_'].some(function (str) {
    return serviceKey.startsWith(str);
  })) {
    var parentServiceKey = serviceKey.split(/_(.+)/)[1];

    if (service[parentServiceKey]) {
      var params = service[parentServiceKey].params;
      return dispatch(submitService(serviceConfig, parentServiceKey, params));
    }
  }
};

export var getServiceMiddleware = function getServiceMiddleware(config) {
  return function (store) {
    return function (next) {
      return function (action) {
        var _actions;

        var dispatch = store.dispatch,
            getState = store.getState;
        next(action);
        var nextState = getState();
        var actions = (_actions = {}, _actions[actionTypes.SERVICE_REGISTER] = function () {
          return fetchService(dispatch, action.payload, config, nextState);
        }, _actions[actionTypes.SERVICE_SET_PARAM_VALUE] = function () {
          return fetchService(dispatch, action.payload, config, nextState);
        }, _actions[actionTypes.SERVICE_SET_PARAM_VALUES] = function () {
          return fetchService(dispatch, action.payload, config, nextState);
        }, _actions[actionTypes.SERVICE_FULFILLED] = function () {
          return handleFulfilled(dispatch, action.payload, config, nextState);
        }, _actions);

        if (actions[action.type]) {
          return actions[action.type]();
        }
      };
    };
  };
};